/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Import_Summary_Nothing_New_TitleInputs */

const en_ui_import_summary_nothing_new_title = /** @type {(inputs: Ui_Import_Summary_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're up to date`)
};

const de_ui_import_summary_nothing_new_title = /** @type {(inputs: Ui_Import_Summary_Nothing_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist auf dem neuesten Stand`)
};

/**
* | output |
* | --- |
* | "You're up to date" |
*
* @param {Ui_Import_Summary_Nothing_New_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_nothing_new_title = /** @type {((inputs?: Ui_Import_Summary_Nothing_New_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_Nothing_New_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_nothing_new_title(inputs)
	return de_ui_import_summary_nothing_new_title(inputs)
});